/**
 * @file   src\components\MemberWantAd\ShareYourAdModal.js
 * @brief  This file is responsible for share want ad.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import Modal from "react-bootstrap/Modal";
import ShareCard from "./ShareCard";
import useIsMobile from "@/hooks/useIsMobile";

const ShareYourAdModal = ({ show, onHide, adDetails, isWantAdCreated,shareLink,fromWantAdDetails,imageLink,fbLink }) => {

  const wantAdId = _.get(adDetails, "wantAdId", "");

  const isMobile = useIsMobile();

  return (
    <Modal
      show={show}
      size="md"
      centered
      className="modal-share"
      onHide={onHide}
      fullscreen={isMobile}
    >
      <Modal.Body className="modal-share__body" style={isMobile ? { justifyContent: 'center', display: 'flex', flexDirection: 'column' } : {}}>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        ></button>

        <ShareCard
          show={show}
          onHide={onHide}
          wantAdId={wantAdId}
          adDetails={adDetails}
          isWantAdCreated={isWantAdCreated}
          shareLink={shareLink}
          imageLink={imageLink}
          fbLink={fbLink}
          fromWantAdDetails={fromWantAdDetails}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ShareYourAdModal;
